import { useMutation } from 'react-apollo';
import { DocumentNode } from 'graphql';
import { useTypedTranslation } from 'translations/typedTranslations';
import { notificationService } from '../views/ui/NotificationService';

export const useMutationWrapper = (
	query: DocumentNode,
	successmessage?: string,
	errorMsg?: string,
	skipMessage?: boolean
) => {
	const { t } = useTypedTranslation();
	const [operation] = useMutation(query);

	return (vars: { variables: any }, successCallback?: any) =>
		operation(vars)
			.then((r) => {
				if (successCallback) {
					successCallback(r);
				}
				if (skipMessage) {
					return;
				}

				notificationService({ success: true }, successmessage || t('OperacionRealizadaExito'));
			})
			.catch((err) => {
				console.log(err, query);
				if (
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "estudiantes_rut_key"' ||
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "estudiantes_email_key"'
				) {
					throw err;
				}
				if (
					err.message ===
					'GraphQL error: Foreign key violation. update or delete on table "grupos" violates foreign key constraint "guia_digital_enviada_grupo_key_fkey" on table "guia_digital_enviada"'
				) {
					notificationService(
						{ error: true },
						'No se puede borrar el equipo porque tiene una guía digital enviada.'
					);
					return;
				}
				if (
					err.message ===
					'GraphQL error: Foreign key violation. update or delete on table "grupos" violates foreign key constraint "respuestas_group_key_fkey" on table "respuestas"'
				) {
					notificationService(
						{ error: true },
						'No se puede borrar el equipo porque tiene respuestas asociadas.'
					);
					return;
				}
				if (skipMessage) {
					return;
				}
				if (
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "chat_denuncias_estudiante_reporta_key_mensaje_key_key"' ||
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "chat_denuncias_mensaje_key_profesor_reporta_key_key"'
				) {
					notificationService(
						{ error: true },
						t('Ya reportaste este mensaje') || t('OperacionNoPudoRealizar')
					);
					return;
				}
				notificationService({ error: true }, errorMsg || t('OperacionNoPudoRealizar'));
			});
};

export const useMutationWrapperReturnStatus = (
	query: DocumentNode,
	successmessage?: string,
	errorMsg?: string,
	skipMessage?: boolean
) => {
	const { t } = useTypedTranslation();
	const [operation] = useMutation(query);

	return (vars: { variables: any }, successCallback?: any) =>
		operation(vars)
			.then((r) => {
				if (successCallback) {
					successCallback(r);
				}
				if (skipMessage) {
					return true;
				}

				notificationService({ success: true }, successmessage || t('OperacionRealizadaExito'));
				return true;
			})
			.catch((err) => {
				if (skipMessage) {
					return false;
				}
				if (err.message === 'Network error: Failed to fetch') {
					notificationService({ error: true }, t('Error de conexión. Verifique su conexión a internet.'));
					return false;
				}
				notificationService({ error: true }, errorMsg || t('OperacionNoPudoRealizar'));
				return false;
			});
};

export const useMutationWrapperNoConnection = (
	query: DocumentNode,
	successmessage?: string,
	errorMsg?: string,
	skipMessage?: boolean
): ((vars: { variables: any }, successCallback?: any) => Promise<boolean>) => {
	const { t } = useTypedTranslation();
	const [operation] = useMutation(query);

	return (vars: { variables: any }, successCallback?: any): Promise<boolean> =>
		operation(vars)
			.then((r) => {
				if (successCallback) {
					successCallback(r);
				}
				if (!skipMessage) {
					notificationService({ success: true }, successmessage || t('OperacionRealizadaExito'));
				}
				return true; // Retorna true si la operación es exitosa
			})
			.catch((err) => {
				console.log(
					err.message ===
						'GraphQL error: Foreign key violation. insert or update on table "respuestas" violates foreign key constraint "respuestas_bloque_key_fkey"',

					err,
					query,
					err.message
				);
				if (
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "chat_denuncias_estudiante_reporta_key_mensaje_key_key"' ||
					err.message ===
						'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "chat_denuncias_mensaje_key_profesor_reporta_key_key"'
				) {
					notificationService({ error: true }, t('Ya reportaste este mensaje'));
				} else if (err.message === 'Network error: Failed to fetch') {
					notificationService(
						{ error: true },
						t('Hubo un problema de conexión al intentar guardar. Intente nuevamente')
					);
				} else if (
					err.message ===
						'GraphQL error: Foreign key violation. insert or update on table "respuestas" violates foreign key constraint "respuestas_bloque_key_fkey"' ||
					err.message ===
						'GraphQL error: Foreign key violation. insert or update on table "respuestas" violates foreign key constraint "respuestas_actividad_key_fkey"'
				) {
					notificationService(
						{ error: true },
						'Esta pregunta fue eliminada por tus docentes. Respalda la información y actualiza'
					);
				} else {
					console.log(err.message);
					notificationService({ error: true }, errorMsg || t('OperacionNoPudoRealizar'));
				}
				return false; // Retorna false si la operación falla
			});
};

export const useMutationWrapperColissionError = (
	query: DocumentNode,
	successmessage?: string,
	errorMsg?: string,
	skipMessage?: boolean
): ((vars: { variables: any }, successCallback?: any) => Promise<boolean>) => {
	const { t } = useTypedTranslation();
	const [operation] = useMutation(query);

	return (vars: { variables: any }, successCallback?: any): Promise<boolean> =>
		operation(vars)
			.then((r) => {
				if (successCallback) {
					successCallback(r);
				}
				if (!skipMessage) {
					notificationService({ success: true }, successmessage || t('OperacionRealizadaExito'));
				}
				return true; // Retorna true si la operación es exitosa
			})
			.catch((err) => {
				console.log(err.message === 'Network error: Failed to fetch', err, query, err.message);
				if (
					err.message ===
					'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "users_rut_key"'
				) {
					notificationService({ error: true }, 'El rut ingresado ya está en uso');
				}
				return false; // Retorna false si la operación falla
			});
};
